/*global angular,env */
'use strict';

angular.module('MrDWebApp')
.controller('MaintenanceCtrl', function($scope,formFactory, $state, $window, $rootScope, $http) {

  var _maintenance = this;

  $scope._rc.bodyClass = 'html-offline';

  // Testing
  // _maintenance.offline_response = {
  //   'title' : 'Huston. We have a problem.',
  //   'friendly_message' : 'We are currently experiencing some difficulty.'
  // };

  // Offline
  if($state.current.name === 'offline') {

    if(!$rootScope.offline_response){

    $http.get(env.apiURL + 'meta/status')
        .success(function (data){
          if(data.error && data.error.http_response_code === 553) {
            _maintenance.offline_response = data.error;
          } else {
            delete _maintenance.offline_response; // Reset
            if (window.env.domainSplit) window.location.href = '/'; else $state.go('home');
          }
        })
        .error(function (data) {
          // This is a little loopy. Throws error if no API is really down.
          _maintenance.offline_response = data.error;
        });

    } else {
      _maintenance.offline_response = $rootScope.offline_response;
    }

  }

});